"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var SlideElements_1 = require("../../SlideElements");
var SignUp_1 = require("./SignUp");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Welcome = function (_a) {
    var promo = _a.promo, welcomeFields = _a.welcomeFields, _b = _a.isFlex, isFlex = _b === void 0 ? false : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var formatCurrency = (0, swr_hooks_1.useCurrencyFormat)();
    var bonusData = (0, swr_hooks_1.useCalculateWelcomePackage)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(SlideElements_1.SlideContainer, { isFlex: isFlex },
            react_1.default.createElement(SlideElements_1.SlideTitle, null, t('welcomeOffer')),
            react_1.default.createElement(SlideElements_1.SecondTitle, null, t('welcomeOfferBonus', {
                percents: bonusData.percent,
                fs: bonusData.freeSpins,
            })),
            breakpoints.xl && react_1.default.createElement(SlideElements_1.ThirdTitle, null, t('letsStartCosmicRide')),
            react_1.default.createElement(SignUp_1.SignUp, { welcomeFields: welcomeFields }))));
};
exports.default = Welcome;
